import {ROUTE_NAMES} from "@/shared/constants/routeNames.ts";
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import type { useAuthStore } from '@/stores/useAuthStore.ts';

export function requirePermissionsModule(
    _to: RouteLocationNormalized,
    _from: RouteLocationNormalized,
    next: NavigationGuardNext,
    authStore: ReturnType<typeof useAuthStore>,
    permissions: string[]
) {
  for (const permission of permissions) {
    if (authStore.hasModule(permission)) {
      return next()
    }
  }
  return next({ name: ROUTE_NAMES.UNAUTHORIZED.name })
}